import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { PhoneHelpComponent } from './phone-help.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [PhoneHelpComponent],
    declarations: [PhoneHelpComponent],
})
export class PhoneHelpModule { }
